<div class="results-container">
  <div class="columns is-multiline is-mobile is-gapless header-container">
    <div class="column is-12-mobile is-6-tablet">
      <div class="wizard-step-header">
        <h1 class="wizard-step-title">{{title}}</h1>
        <p *ngIf="!showTopNumberOfItemsMessage" class="wizard-step-subtitle">{{subtitle}}</p>
      </div>
    </div>
    <div class="column is-hidden-mobile is-6-tablet header-button-container">
      <div>
        <button mat-flat-button class="secondary" (click)="handleStartOverClick()">{{startOverButtonText}}</button>
      </div>
      <div *ngIf="showShareResultsButton">
        <button mat-flat-button class="primary header-share-results-button" (click)="handleShareResultsClick()">{{shareResultsButtonText}}</button>
      </div>
      <div *ngIf="showSaveResultsButton">
        <button mat-flat-button class="primary header-share-results-button" (click)="handleShowSaveResultsClick()">SAVE RESULTS</button>
      </div>
    </div>
  </div>
  <!-- results content -->
  <div class="columns is-multiline is-mobile is-gapless">
    <!-- info and filtering -->
    <div class="column is-12-mobile is-3-tablet">
      <div class="is-hidden-mobile" *ngIf="showTopNumberOfItemsMessage">
        <h1 class="results-msg">{{topNumberOfItemsMessage}}</h1>
      </div>
      <div class="columns is-multiline is-mobile is-gapless">
        <!-- your selections -->
        <div class="column is-half-mobile is-full-tablet mobile-banner-column mobile-banner-left-column">
          <app-selections></app-selections>
        </div>
        <div class="column is-hidden-mobile">
          <div class="buffer-large"></div>
        </div>
        <!-- perfect for -->
        <div class="column is-half-mobile is-full-tablet mobile-banner-column mobile-banner-right-column">
          <app-ideal-use-case></app-ideal-use-case>
        </div>
        <!-- mobile filter button and messages -->
        <div class="column is-full is-hidden-tablet">
          <div class="buffer-medium"></div>
          <div class="columns is-multiline is-mobile is-gapless is-vcentered">
            <div class="column">
              <div *ngIf="showNoResultsMessage">
                <label class="mobile-results-message">{{noResultsMessage}}</label>
              </div>
              <div *ngIf="showTopNumberOfItemsMessage">
                <label class="mobile-results-message">{{topNumberOfItemsMessageMobile}}</label>
              </div>
            </div>
            <div class="column filters-button-container">
              <button mat-flat-button class="secondary" (click)="handleMobileFiltersButtonClick()">
                <span>{{filtersTitle}} ({{selectedFiltersCount}}) </span>
                <mat-icon
                  *ngIf="!showMobileFilters"
                  class="filter-button-icon"
                  inline=true
                  fontSet="fas"
                  fontIcon="fa-chevron-down"
                  ></mat-icon>
                <mat-icon
                  *ngIf="showMobileFilters"
                  class="filter-button-icon"
                  inline=true
                  fontSet="fas"
                  fontIcon="fa-chevron-up"
                  ></mat-icon>
              </button>
            </div>
          </div>
        </div>
        <!-- tablet and desktop filters -->
        <div class="columns is-multiline is-gapless is-hidden-mobile">
          <div class="column">
            <div class="buffer-large"></div>
          </div>
          <div class="column is-full">
            <label class="info-header">{{filtersTitle}}</label>
            <div class="buffer-small"></div>
          </div>
          <!-- form factors -->
          <div class="column is-full-tablet">
            <app-form-factors-filters #formFactorFilters (formFactorsToFilterBy)="handleFormFactorFilter($event)"></app-form-factors-filters>
          </div>
          <div class="column">
            <div class="buffer-large"></div>
          </div>
          <!-- screen sizes -->
          <div class="column is-full-tablet">
            <app-screen-size-filters #screenSizeFilters (screenSizesToFilterBy)="handleScreenSizeFilter($event)"></app-screen-size-filters>
          </div>
          <div class="column">
            <div class="buffer-large"></div>
          </div>
          <!-- brands -->
          <div class="column is-full-tablet">
            <app-brand-filters #brandFilters (brandsToFilterBy)="handleBrandsFilter($event)" (setInitialSelectedBrands)="setInitialSelectedBrands($event)"></app-brand-filters>
          </div>
          <div class="column">
            <div class="buffer-large"></div>
          </div>
          <!-- features -->
          <div class="column is-full-tablet">
            <app-feature-filters #featureFilters (featuresToFilterBy)="handleFeatureFilter($event)"></app-feature-filters>
          </div>
          <div class="column">
            <div class="buffer-large"></div>
          </div>
          <!-- os types -->
          <div class="column is-full-tablet">
            <app-os-type-filters #osTypeFilters [isEnterpriseWorkflow]="isEnterprisePrimaryUse" (osTypesToFilterBy)="handleOsTypeFilter($event)" (setInitialSelectedOsTypes)="setInitialSelectedOsTypes($event)"></app-os-type-filters>
          </div>
          <div class="column">
            <div class="buffer-large"></div>
            <div class="buffer-large"></div>
          </div>
          <!-- AUE link desktop -->
          <div class="column is-full-tablet" *ngIf="showAUELink">
            <app-aue-link></app-aue-link>
          </div>
        </div>
        <!-- mobile sorting & filters -->
        <div class="column is-full is-hidden-tablet">
          <div class="columns is-multiline is-mobile is-gapless mobile-filters-section-container" [ngClass]="{ 'visible-mobile' : showMobileFilters }">
            <!-- price sorting -->
            <div class="column is-full-mobile">
              <app-price-sorting (changePriceSorting)="handlePriceSorting($event)"></app-price-sorting>
            </div>
            <!-- checkbox filters -->
            <div class="column is-half-mobile">
              <app-form-factors-filters (formFactorsToFilterBy)="handleFormFactorFilter($event)"></app-form-factors-filters>
              <div class="buffer-medium"></div>
              <app-brand-filters (brandsToFilterBy)="handleBrandsFilter($event)" (setInitialSelectedBrands)="setInitialSelectedBrands($event)"></app-brand-filters>
            </div>
            <div class="column is-half-mobile">
              <app-screen-size-filters (screenSizesToFilterBy)="handleScreenSizeFilter($event)"></app-screen-size-filters>
              <div class="buffer-medium"></div>
              <app-feature-filters (featuresToFilterBy)="handleFeatureFilter($event)"></app-feature-filters>
              <div class="buffer-medium"></div>
              <app-os-type-filters [isEnterpriseWorkflow]="isEnterprisePrimaryUse" (osTypesToFilterBy)="handleOsTypeFilter($event)" (setInitialSelectedOsTypes)="setInitialSelectedOsTypes($event)"></app-os-type-filters>
            </div>
            <!-- AUE link mobile -->
            <div class="column is-full-mobile" *ngIf="showAUELink">
              <app-aue-link></app-aue-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="buffer-medium is-hidden-tablet"></div>
    <div class="column is-hidden-mobile is-narrow"><div class="buffer-column-container"></div></div>
    <!-- chromebooks list -->
    <div class="column is-12-mobile">
      <div class="is-hidden-mobile">
        <app-filter-chips
          [isEnterpriseWorkflow]="isEnterprisePrimaryUse"
          [formFactorFilters]="filterItemsFromCheckboxParams.formFactors"
          [screenSizeFilters]="filterItemsFromCheckboxParams.screenSizes"
          [brandFilters]="filterItemsFromCheckboxParams.brands"
          [featureFilters]="filterItemsFromCheckboxParams.features"
          [osTypeFilters]="filterItemsFromCheckboxParams.osTypes"
          (updateFormFactorFilter)="formFactorFilters.onFormFactorChange($event)"
          (updateScreenSizeFilter)="screenSizeFilters.onScreenSizeFilterChange($event)"
          (updateBrandFilter)="brandFilters.onBrandFilterChange($event)"
          (updateFeatureFilter)="featureFilters.onFeatureChange($event)"
          (updateOsTypeFilter)="osTypeFilters.onOsTypeChange($event)"
        ></app-filter-chips>
        <app-price-sorting (changePriceSorting)="handlePriceSorting($event)"></app-price-sorting>
      </div>
      <div *ngIf="resultsLoading" class="spinner-container">
        <mat-spinner diameter="75" aria-label="Loading indicator for results being retrieved."></mat-spinner>
        <div class="buffer-small"></div>
      </div>
      <div class="is-hidden-mobile">
        <div *ngIf="showNoResultsMessage">
          <h1 class="results-msg no-matching-results-msg">{{noResultsMessage}}</h1>
        </div>
      </div>
      <div *ngFor="let group of displayedDeviceGroups">
        <app-device-result [group]="group"></app-device-result>
      </div>
      <div *ngIf="enableLoadMore" class="load-more-button-container">
        <button mat-flat-button class="primary" (click)="loadMoreDevices()">{{loadMoreButtonText}}</button>
      </div>
    </div>
  </div>
</div>
<span class="is-hidden-tablet">
  <div class="mobile-navigation-container" [ngClass]="{ 'non-english' : isNonEnglishLocale }">
    <button mat-flat-button class="secondary" (click)="handleStartOverClick()">{{startOverButtonText}}</button>
    <div *ngIf="showShareResultsButton">
      <button mat-flat-button class="primary" (click)="handleShareResultsClick()">{{shareResultsButtonText}}</button>
    </div>
  </div>
</span>
<span class="is-hidden-mobile">
  <app-progress-bar [step]="currentStep" [stepNumber]="stepNumber"></app-progress-bar>
</span>
<form *ngIf="marketoFormId !== ''" [attr.id]="'mktoForm_' + marketoFormId" style="display:none"></form>
